import React from "react"
import { Tooltip } from "react-tooltip"

import useSectionRetake from "../../../hooks/useSectionRetake"
import { getAssetPath } from "../../../utils/assets"

// Retake CTA for a single PQ Index section. Uses the shared useSectionRetake flow
// (also used by the overview page's SectionRetakeDropdown), so both entry points
// stay in sync. Disabled with a tooltip when the participant's enrolment is not
// active.
//
// `sectionLabel` is the human-readable section name (e.g. "Biological Age"). The
// button and its info tooltip state explicitly that only this section is retaken —
// not the whole PQ Index calculator.
function SectionRetakeButton({
  baseUrl, section, sectionLabel, enrolment
}) {
  const { startRetake, busy, isActive } = useSectionRetake(baseUrl, enrolment)

  const tooltipId = `section-retake-${section}`
  const infoTooltipId = `section-retake-info-${section}`
  const sectionName = sectionLabel || "this section"
  const infoMessage = `This retakes only the ${sectionName} questions, not the whole PQ Index. `
    + "Your other sections stay unchanged and your PQ Index is recalculated afterwards."

  return (
    <>
      <span data-tooltip-id={tooltipId} className="d-inline-block">
        <button
          type="button"
          className="btn btn-black btn-sm"
          onClick={() => startRetake(section)}
          disabled={!isActive || busy}
          style={isActive ? undefined : { pointerEvents: "none" }}>
          {busy ? "Starting…" : "Retake this section"}
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" fill="currentColor" className="ml-1" style={{ verticalAlign: "middle" }}>
            <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </span>
      <button
        type="button"
        data-tooltip-id={infoTooltipId}
        className="ml-2 p-0 border-0 bg-transparent"
        aria-label={infoMessage}
        style={{ cursor: "help", verticalAlign: "middle" }}>
        <img alt="" aria-hidden="true" src={getAssetPath("icn-info")} />
      </button>
      <Tooltip className="tooltip" id={infoTooltipId} place="top">
        <span>{infoMessage}</span>
      </Tooltip>
      {!isActive && (
        <Tooltip className="tooltip" id={tooltipId} place="top">
          <span>Your program is no longer active, so this section can&apos;t be retaken.</span>
        </Tooltip>
      )}
    </>
  )
}

export default SectionRetakeButton
